export class TipoServicoModel {
    nomeIntegracao: string;
    descricao: string;

    constructor(nomeIntegracao: string, descricao: string) {
        this.nomeIntegracao = nomeIntegracao;
        this.descricao = descricao;
    }

}

export const tipoServicoList: TipoServicoModel[] = [
    new TipoServicoModel("GUINCHO", "Guincho"),
    new TipoServicoModel("CHAVEIRO", "Chaveiro"),
    new TipoServicoModel("BATERIA", "Carga de bateria"),
    new TipoServicoModel("TROCA_PNEU", "Troca de pneu"),
    new TipoServicoModel("TRANSPORTE_ASSOCIADO", "Transporte ao associado"),

]


